import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const QUESTION_ANSWERED = 'question-answered'

export default {
  [PORTUGUESE]: {
    [QUESTION_ANSWERED]: (questionResult, average) =>
      `Esta pergunta foi respondida ${questionResult} vezes, com uma
      média de ${average}`,
  },

  [ENGLISH]: {
    [QUESTION_ANSWERED]: (questionResult, average) =>
      `This question was answered ${questionResult} times, with an
      average of ${average}`,
  },

  [SPANISH]: {
    [QUESTION_ANSWERED]: (questionResult, average) =>
      `Esta pregunta fue respondida ${questionResult} veces, con una
      promedio de ${average}`,
  },
}
